import { render, staticRenderFns } from "./buyer_loans_table.vue?vue&type=template&id=c33f12fa&"
import script from "./buyer_loans_table.vue?vue&type=script&lang=js&"
export * from "./buyer_loans_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports